export interface Stat {
  value: number;
  label: string;
  suffix: string;
  icon: string;
}

export const stats: Stat[] = [
  { value: 12458, label: "Radios Activas", suffix: "+", icon: "ri-radio-line" },
  { value: 89234, label: "Oyentes Conectados", suffix: "+", icon: "ri-headphone-line" },
  { value: 456721, label: "Publicaciones", suffix: "+", icon: "ri-file-text-line" },
  { value: 67, label: "Países", suffix: "", icon: "ri-global-line" },
];